var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaGradientGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 32,
    stroke: "url(#paint0_linear_1159_190)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5866 20H28.3108C23.7282 20 20 23.7282 20 28.3108V39.5866C20 44.1692 23.7282 47.8974 28.3108 47.8974H39.5866C44.1692 47.8974 47.8974 44.1692 47.8974 39.5866V28.3108C47.8974 23.7282 44.1692 20 39.5866 20ZM45.0892 39.5867C45.0892 42.6266 42.6248 45.091 39.5848 45.091H28.309C25.2691 45.091 22.8047 42.6266 22.8047 39.5867V28.3108C22.8047 25.2709 25.2691 22.8065 28.309 22.8065H39.5848C42.6248 22.8065 45.0892 25.2709 45.0892 28.3108V39.5867ZM26.7344 33.9486C26.7344 29.9702 29.9711 26.7334 33.9496 26.7334C37.9282 26.7334 41.1649 29.9701 41.1649 33.9486C41.1649 37.9271 37.9282 41.1639 33.9496 41.1639C29.9711 41.1639 26.7344 37.9271 26.7344 33.9486ZM33.9479 38.3575C31.5129 38.3575 29.5391 36.3836 29.5391 33.9487C29.5391 31.5138 31.513 29.5399 33.9479 29.5399C36.3828 29.5399 38.3566 31.5138 38.3566 33.9487C38.3566 36.3836 36.3827 38.3575 33.9479 38.3575ZM41.1781 28.5166C42.133 28.5166 42.9071 27.7425 42.9071 26.7876C42.9071 25.8328 42.133 25.0587 41.1781 25.0587C40.2233 25.0587 39.4492 25.8328 39.4492 26.7876C39.4492 27.7425 40.2233 28.5166 41.1781 28.5166Z",
    fill: "url(#paint1_linear_1159_190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_190",
    x1: 2,
    y1: 66,
    x2: 66,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_190",
    x1: 20,
    y1: 47.8974,
    x2: 47.8974,
    y2: 47.8974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A3FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697676,
    stopColor: "#BB2E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D02670"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaGradientGradient);
export default __webpack_public_path__ + "static/media/InstaGradientGradient.30d5d8872e090264791c9880bf04b288.svg";
export { ForwardRef as ReactComponent };